import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import * as Fields from '../kyc-fields/kyc-fields.json';
import * as EmploymentOptions  from '../kyc-fields/employment-options.json';
import * as Lgas from '../kyc-fields/lga.json';
import { KycService } from '../../../../../shared/services/kyc.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { FundingService } from '../../../../../shared/services/funding.service';
import { FaqCardModel } from 'src/app/views/partials/faq-card/faq-card.component';
import { DatePipe } from '@angular/common';
import moment from 'moment';
@Component({
    selector: 'app-kyc',
    templateUrl: './kyc.component.html',
    styleUrls: ['./kyc.component.scss'],
})
export class KycComponent implements OnInit {
    /**
     * Data Properties
     */

    kycCards = [];

    currentSection = 0;
    otp: string;
    employmentOptions = (EmploymentOptions as any).default;
    employmentTypes = this.employmentOptions.types;
    employmentPositions = this.employmentOptions.positions;

    lgas = (Lgas as any).default.lgNames;
    countries = (Lgas as any).default.country;
    kycFields: string[] = (Fields as any).default.fields;
    kycStatus = (Fields as any).default.fields;
    isCardComplete: boolean;
    selectOptions = [];

    errors = {};
    final: any;
    kycObject: any = {};
    userId: any;

    name: any;
    phone: string;
    Id: any;
    kycStatuses: any;
    Position: any;
    kycName = [];
    stage: boolean = false;
    actBank: boolean = false;
    errMsg:string;
    error: boolean;

    faqQuestions: FaqCardModel = {
        title: 'Common Question',
        faqs: [
            {
                question: 'How are you doing today',
                answer: "I'm doing perfectly fine",
            },
            {
                question: 'How are you doing today',
                answer: "I'm doing perfectly fine",
            },
            {
                question: 'How are you doing today',
                answer: "I'm doing perfectly fine",
            },
            {
                question: 'How are you doing today',
                answer: "I'm doing perfectly fine",
            },
        ],
    };
    section: number;

    /**
     * Computed properties
     */

    constructor(
        private api: KycService,
        private SpinnerService: NgxSpinnerService,
        private toastr: ToastrService,
        private route: Router,
        private fund: FundingService
    ) { }

    ngOnInit() {
        this.loadKyc();
    }

    get currentKycCard() {
        //kycQuestion to know which card call to invoke
        if (this.kycName.length > 0) {

            let key = Object.keys(this.kycName)[this.currentSection];

            let keyValue = this.kycName[key];

            if (keyValue.key == 'OTP Confirmation') {
                this.stage = true;
            } else {
                this.stage = false;
            }

            const kycQuestion = this.kycStatus.findIndex(
                (data) => data.title === keyValue.key
            );

            return this.kycFields[kycQuestion];
        }
        
        return {};
        
    }
    get canSkipCard() {
        return this.currentSection === 4;
    }
    get hasErrors() {
        return Object.keys(this.errors).length > 0;
    }

    /**
     * Methods
     */

    loadKyc() {
        this.SpinnerService.show();
        //get user profile
        this.api.getProfile().subscribe(
            (res: any) => {
                //set kyc status
                this.kycStatuses = res.data;

                //check for kyc that have not been completed
                if (
                    this.kycStatuses.disclosureName == null ||
                    this.kycStatuses.disclosureName == ''
                ) {
                    this.kycName.push({
                        key: 'Your Name',
                    });
                    this.kycCards.push({
                        key: 'Your Name',
                    });
                }
                if (
                    this.kycStatuses.dob == null ||
                    this.kycStatuses.dob == ''
                ) {
                    this.kycName.push({
                        key: 'Date of Birth',
                    });
                    this.kycCards.push({
                        key: 'Date of Birth',
                    });
                }
                if (
                    this.kycStatuses.phone == null ||
                    this.kycStatuses.bvn == "" || this.kycStatuses.phone == ""
                ) {
                    this.kycName.push({
                        key: 'BVN Verification',
                    });
                    this.kycCards.push({
                        key: 'BVN Verification',
                    });
                }
                if (this.kycStatuses.phoneVerified == false) {
                    this.kycName.push({
                        key: 'OTP Confirmation',
                    });
                    this.kycName.push({
                        key: 'New Phone Number',
                    });
                    this.kycCards.push({
                        key: 'OTP Confirmation',
                    });
                }
                if (
                    this.kycStatuses.bankAcctNo == null ||
                    this.kycStatuses.bankAcctNo == '' ||
                    this.kycStatuses.bankAcctName == null ||
                    this.kycStatuses.bankAcctName == ''
                ) {
                    this.kycName.push({
                        key: 'Bank Details',
                    });
                    this.kycCards.push({
                        key: 'Bank Details',
                    });
                }

                if (
                    this.kycStatuses.gender == null ||
                    this.kycStatuses.maritalStatus == null ||
                    this.kycStatuses.address == null ||
                    this.kycStatuses.postalCode == null ||
                    this.kycStatuses.lg == null ||
                    this.kycStatuses.country == null ||
                    this.kycStatuses.city == null
                ) {
                    this.kycName.push({
                        key: 'Postal Address',
                    });
                    this.kycCards.push({
                        key: 'Postal Address',
                    });
                }
                if (
                    this.kycStatuses.employmentStatus == null ||
                    this.kycStatuses.employedByBroker == null
                ) {
                    this.kycName.push({
                        key: 'Employment Details',
                    });
                    this.kycCards.push({
                        key: 'Employment Details',
                    });
                }
                if (
                    this.kycStatuses.riskTolerance == null ||
                    this.kycStatuses.annualIncome == null ||
                    this.kycStatuses.investmentObjective == null ||
                    this.kycStatuses.networthLiquid == null ||
                    this.kycStatuses.networthTotal == null
                ) {
                    this.kycName.push({
                        key: 'Investment Preferences',
                    });
                    this.kycCards.push({
                        key: 'Investment Preferences',
                    });
                }
                if (
                    this.kycStatuses.addressProofFileName == null ||
                    this.kycStatuses.addressProofUrl == null ||
                    this.kycStatuses.photoIdFileName == null ||
                    this.kycStatuses.photoIdUrl == null ||
                    this.kycStatuses.profileImageFilename == null ||
                    this.kycStatuses.profileImageUrl == null
                ) {
                    this.kycName.push({
                        key: 'Proof Of Identity',
                    });
                    this.kycCards.push({
                        key: 'Proof Of Identity',
                    });
                }


                this.userId = res.data.id;
                this.Id = res.data.userId;

                //display empty state if no question
                if(this.kycName.length > 0){
                    this.error = false;
                }
                else{
                    this.error = true;
                    this.errMsg= 'Kyc Questions Completed'
                }
                //hide spinner
                this.SpinnerService.hide();
            },
            (err) => {

                this.SpinnerService.hide();
                this.error=true;
                this.errMsg=err.error.message;

                    if(this.errMsg === undefined)
                    this.errMsg = 'Network Error. Please check your connectivity.'
                    else{
                        this.errMsg=err.error.message;
                    }

            }
        );
    }
    inputKeyUp(e) {
        // set key and value;

        if (e.name === 'otp') {
            this.submitOtp(e);
            return;
        }

        this.kycObject[e.name] = e.value;
        this.final = e.value;
        this.name = e.name;
    }

    uploadImage(e) { }

    otpKeyPress(e) { }

    setItemClass(item) {
        const classes = {
            complete: item.complete,
            active: this.currentSection === item.name,
        };
        return classes;
    }

    onSubmit() {
        if (this.name == 'bvn') {
            this.checkBvn();
        }
        else if (this.name == 'phone') {
            this.phone = this.final;
            this.updateKyc();
        }
        else if (this.name == 'dob') {

            let today = moment();
            let birthdate = moment(this.final);
            let years = today.diff(birthdate, 'years');

            if (years >= 18) {
                let formatedDate = new DatePipe('en-US').transform(this.final, 'dd/MM/yyyy')
                this.kycObject['dob'] = formatedDate;
                this.updateKyc();

            }
            else {
                this.final = "";
                this.toastr.error('User should not be less than 18 years of age !', 'KYC Error!', {
                    positionClass: 'toast-bottom-center',
                    timeOut: 5000,
                });
            }

        }
        else {
            if(this.kycName.length > 0){
                if (this.final === '' || this.final == undefined) {
                 
                    this.toastr.warning(
                        'Please fill all fields !',
                        'Empty field detected!',
                        {
                            positionClass: 'toast-bottom-center',
                            timeOut: 5000,
                        }
                    );
                } else {
                    if (!this.hasErrors) {
                        this.updateKyc();
                    }
                }
            }
            else{
                this.route.navigate(['/dashboard/portfolio']);
            }

            
        }
    }

    submitOtp(e) {
        if (!e.value) {
            this.otp = undefined;
            return;
        }
        this.otp = e.value;
        this.final = this.otp;
        this.kycObject['otp'] = this.otp;
    }

    goToNextCard() {
        this.kycObject = {};

        if (this.currentSection < this.kycCards.length - 1) {
            this.currentSection += 1;
           
        }
        // else if(this.currentSection >= this.kycCards.length - 1) {
        //     this.currentSection += 1;
        //     console.log(this.currentSection, 'new value')
        // }
        
        else {
            // console.log(this.currentSection, 'mn')

            this.toastr.info('Kyc completed !', 'KYC Success!', {
                positionClass: 'toast-bottom-center',
                timeOut: 5000,
            });
            this.route.navigate(['/onboarding/menu']);
        }
    }

    goToPrevCard() {
        this.currentSection -= 1;
    }

    goToCard(name: any) {
        if (name == 'OTP Confirmation') {
            this.stage = true;
        } else {
            this.stage = false;
        }
        this.currentSection = this.kycName.findIndex(
            (data) => data.key === name
        );
    }

    skipCard() {
        this.goToNextCard();
    }

    goToOtpCard() {
        this.currentSection = this.kycName.findIndex(
            (data) => data.key === 'OTP Confirmation'
        );
    }

    goToPhoneCard() {
        this.stage = false;
        this.currentSection = this.kycName.findIndex(
            (data) => data.key === 'New Phone Number'
        );
    }

    resetErrors() {
        this.errors = {};
    }

    getOptions(value) {
        if (value == 'bankId') {
            this.actBank = true;
        } else {
            this.actBank = false;
        }

        switch (value) {
            case 'lg':
                return this.lgas;

            case 'employmentPosition':
                return this.employmentPositions;

            case 'employmentType':
                return this.employmentTypes;
            case 'country':
                return this.countries;
            default:
                return [];
        }
    }

    updateKyc() {
        if (this.otp != undefined && this.otp != '') {
            this.verifyOtp();
        } else {
            //update kyc

            this.SpinnerService.show();
            this.api.updateKYC(this.kycObject).subscribe(
                (res: any) => {
                    if ((res.code = 200 && res.data)) {
                        if (
                            this.phone != '' &&
                            this.phone != undefined &&
                            this.phone != null
                        ) {
                            this.sendOtp();
                            this.kycObject = {};
                            this.kycObject['id'] = this.userId;
                            this.final = '';
                            this.name = '';
                            this.otp = '';
                            this.phone = '';

                            this.goToOtpCard();
                        } else {
                            this.kycObject = {};
                            this.kycObject['id'] = this.userId;
                            this.final = '';
                            this.name = '';
                            this.otp = '';

                            this.goToNextCard();
                        }
                    }
                    this.SpinnerService.hide();
                },
                (err) => {
                    this.SpinnerService.hide();
                   
                    this.toastr.error(err.error.message, 'KYC Error!', {
                        positionClass: 'toast-bottom-center',
                        timeOut: 5000,
                    });
                }
            );
        }
    }

    checkBvn() {
        this.SpinnerService.show();
        this.api.checkBvn(this.final).subscribe(
            (res: any) => {
                this.phone = res.data.mobile;
                this.kycObject['phone'] = this.phone;
                this.updateKyc();
                // this.sendOtp();
                this.SpinnerService.hide();
            },
            (err) => {
                this.SpinnerService.hide();
                this.toastr.error(err.error.message, 'Bvn Error!', {
                    positionClass: 'toast-bottom-center',
                    timeOut: 2000,
                });
            }
        );
    }

    //verifyOtp
    verifyOtp() {
        this.SpinnerService.show();

        this.api.validateOtp(this.final).subscribe(
            (res: any) => {

                this.otp = '';
                this.phone = '';
                this.final = "";
                this.kycObject['phoneVerified'] = 1
                // console.log(this.kycObject,'kcy')
                this.api.updateKYC(this.kycObject).subscribe((res: any) => {
                    this.section = this.kycName.findIndex(
                        (data) => data.key === 'New Phone Number'
                    );
                    this.kycName.splice(this.section, 1);
                    this.toastr.info('Otp verified!', 'Otp Success!', {
                        positionClass: 'toast-bottom-center',
                        timeOut: 2000,
                    });
                    this.goToNextCard();
                    this.SpinnerService.hide();

                })

            },
            (err) => {
                this.toastr.error(err.error.message, 'Otp Error!', {
                    positionClass: 'toast-bottom-center',
                    timeOut: 2000,
                });
                this.SpinnerService.hide();
                this.otp = '';
                this.final = "";

                // this.goToNextCard();
            }
        );
    }

    //sendOtp
    sendOtp() {
        this.SpinnerService.show();
        this.api.sendOtp(this.phone).subscribe(
            (res: any) => {
                if (res.code == 200) {
                    this.toastr.info(
                        'Otp sent to registered phone number!',
                        'Otp Success!',
                        {
                            positionClass: 'toast-bottom-center',
                            timeOut: 2000,
                        }
                    );
                    this.phone = '';
                }
                this.SpinnerService.hide();
            },
            (err) => {
                this.SpinnerService.hide();
                this.toastr.error(
                    err.error.message,
                    'Otp Error!',
                    {
                        positionClass: 'toast-bottom-center',
                        timeOut: 2000,
                    }
                );
            }
        );
    }

}